import * as actionTypes from "constants/actionTypes";

const initialState = {
  synced: false,
  checklists: {},
  addingItem: false
};

export default function checklists(state = initialState, action) {
  switch (action.type) {
    case actionTypes.REPLACE_ACCOUNT_CHECKLIST: {
      const { checklist, checklistId } = action.payload;

      if (checklist) {
        return {
          ...state,
          checklists: {
            ...state.checklists,
            [checklistId]: checklist
          }
        };
      }

      const {
        [checklistId]: omit,
        ...stateWithoutChecklist
      } = state.checklists;
      return { ...state, checklists: stateWithoutChecklist };
    }

    case actionTypes.REPLACE_ACCOUNT_CHECKLISTS:
      return {
        ...state,
        synced: true,
        checklists: action.payload
      };

    case actionTypes.UPDATE_CHECKLIST_IN_STORE: {
      const { changes } = action.payload;
      return {
        ...state,
        checklists: {
          ...state.checklists,
          [action.payload.checklistId]: {
            ...state.checklists[action.payload.checklistId],
            ...changes
          }
        }
      };
    }

    case actionTypes.UPDATE_CHECKLIST_ITEM_IN_STORE:
      return {
        ...state,
        checklists: {
          ...state.checklists,
          [action.payload.checklistId]: {
            ...state.checklists[action.payload.checklistId],
            items: {
              ...state.checklists[action.payload.checklistId].items,
              [action.payload.checklistItemId]: {
                ...state.checklists[action.payload.checklistId].items[
                  action.payload.checklistItemId
                ],
                ...action.payload.changes
              }
            }
          }
        }
      };

    case actionTypes.ADD_CHECKLIST_ITEM_FETCHING:
      return {
        ...state,
        addingItem: true
      };

    case actionTypes.ADD_CHECKLIST_ITEM_FETCHED:
      return {
        ...state,
        addingItem: false
      };

    default:
      return state;
  }
}

export const selectAccountChecklists = state =>
  state.account.checklists.checklists;
export const selectAccountChecklist = (state, checklistId) =>
  selectAccountChecklists(state)[checklistId];
export const selectChecklistAddingItem = state =>
  state.account.checklists.addingItem;
export const selectAccountChecklistsSynced = state =>
  state.account.checklists.synced;
